import { useFormik } from "formik";
import { Button } from "primereact/button";
import React from "react";
import * as Yup from "yup";
import { useTranslation } from "@i18n/hooks";
import { ProductSelection, ProductSelectionFormProps } from "./product-selection-form.interface";
import { DefaultIntegerFieldComponent } from "../../../components/DefaultTextInput";
import { ValidatedField } from "../../../components/ValidatedField";
import { SelectProductFieldDialog } from "../select-product-field-dialog";
import { Product } from "../select-product-field-dialog/select-product-field-dialog.interface";

export const ProductSelectionForm = ({
	onBack,
	onSubmit,
	isLoading,
	initialValues,
}: ProductSelectionFormProps) => {
	const { t } = useTranslation("common");
	const formik = useFormik<ProductSelection>({
		initialValues: initialValues,
		enableReinitialize: true,
		validationSchema: Yup.object().shape({
			product: Yup.object().required(t("product.required")),
			amount: Yup.number().min(1).required(t("product.amountRequired")),
		}),
		onSubmit: (values, { setSubmitting }) => {
			onSubmit({
				product: values.product,
				amount: values.amount,
			});
			setSubmitting(false);
		},
	});

	return (
		<>
			<form onSubmit={formik.handleSubmit} className="p-fluid">
				<ValidatedField<ProductSelection, Product>
					name={"product"}
					label={t("product.product")}
					component={SelectProductFieldDialog}
					required
					formikConfig={formik}
				/>
				<ValidatedField<ProductSelection, number>
					name={"amount"}
					label={t("order.amount")}
					required
					component={DefaultIntegerFieldComponent}
					formikConfig={formik}
				/>

				<Button
					disabled={isLoading}
					type="submit"
					label={t("actions.save")}
					className="mt-2"
				/>
				<Button
					disabled={isLoading}
					label={t("actions.back")}
					type="button"
					onClick={onBack}
					className="mt-2"
				/>
			</form>
		</>
	);
};
